import React from 'react';
import { Button, Menu, MenuItem } from '@material-ui/core';
import TranslateIcon from '@material-ui/icons/Translate';
import { NavLink } from 'react-router-dom';
import { LangContext } from '../../contexts/lang.context';

export const LanguageSwitcher: React.FC = () => {
  const { APP } = React.useContext(LangContext).currentLangData;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (lang: string) => {
    localStorage.setItem('lang', lang);
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleButtonClick}
        startIcon={<TranslateIcon />}
      >
        {APP.lang}
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <NavLink to="/en" style={{ textDecoration: 'none', color: 'black' }}>
          <MenuItem onClick={() => handleClose('en')}>English</MenuItem>
        </NavLink>
        <NavLink to="/zh" style={{ textDecoration: 'none', color: 'black' }}>
          <MenuItem onClick={() => handleClose('zh')}>正體中文</MenuItem>
        </NavLink>
        <NavLink to="/ja" style={{ textDecoration: 'none', color: 'black' }}>
          <MenuItem onClick={() => handleClose('ja')}>日本語</MenuItem>
        </NavLink>
      </Menu>
    </div>
  );
};
